import { Injectable } from '@angular/core';
import { Utils } from './utils';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public isLocalStorageAvailable = false;
  constructor() {
    const test = 'test';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      this.isLocalStorageAvailable = true;
    } catch (e) {
      this.isLocalStorageAvailable = false;
    }
  }
  public setItem(key: string, value: string) {
    if (!this.isLocalStorageAvailable) return null;
    localStorage.setItem(key, value);
  }

  public getItem(key: string) {
    if (!this.isLocalStorageAvailable) return null;
    return localStorage?.getItem(key);
  }

  public removeItem(key: string) {
    if (!this.isLocalStorageAvailable) return null;
    localStorage.removeItem(key);
  }

  public clear() {
    if (!this.isLocalStorageAvailable) return null;
    localStorage.clear();
  }

  isValidToken(token: string): boolean {
    return typeof token === 'string' && token.length === 36;
  }

  setToken(token_id: string) {
    if (!this.isValidToken(token_id)) {
      //generate a new token_id if it's not a valid UUID
      token_id = Utils.generateUUID();
    }

    this.token = token_id;
    this.setItem('TOKEN', JSON.stringify(token_id));
  }

  private token: string;

  getToken() {
    if (this.token && this.isValidToken(this.token)) {
      this.setItem('TOKEN', JSON.stringify(this.token));
      return this.token;
    }

    const token = JSON.parse(this.getItem('TOKEN') || 'null');

    //check if token is a uuid string
    if (this.isValidToken(token)) {
      this.token = token;
      return this.token;
    } else {
      this.setToken(Utils.generateUUID());
      return this.token;
    }
  }
}
